// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Staging (legal-video-frontend)
  portal_url: 'https://staging-pulse.tips.in',
  // portal_url: 'http://localhost:8055',
  portal_upload_url: 'https://staging-pulse.tips.in',
  // portal_upload_url: 'http://localhost:8055',
  // Incoming legal-marketing-frontend staging:
  // portal_url: 'https://staging-rcc.mobify.bz',
  // portal_upload_url: 'https://staging-rcc.mobify.bz',
  bulk_upload_module_url: 'https://bulk-upload.tips.in',

  // Local Directus:
  // portal_url: 'http://localhost:8055',
  // portal_upload_url: 'http://localhost:8055',
  // portal_url: 'https://pulse.tips.in',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
